import { useEffect, useRef, useState } from 'react'

export interface Countdown {
  hours: string
  minutes: string
  seconds: string
}

const START_SECONDS = 23 * 3600 + 59 * 60 + 32

function pad(value: number): string {
  return String(Math.max(0, Math.floor(value))).padStart(2, '0')
}

export function useCountdown(): Countdown {
  const deadline = useRef<number>(Date.now() + START_SECONDS * 1000)
  const [remaining, setRemaining] = useState<number>(START_SECONDS)

  useEffect(() => {
    const tick = () => {
      const diff = Math.max(0, Math.round((deadline.current - Date.now()) / 1000))
      setRemaining(diff)
    }
    tick()
    const id = window.setInterval(tick, 1000)
    return () => window.clearInterval(id)
  }, [])

  return {
    hours: pad(remaining / 3600),
    minutes: pad((remaining % 3600) / 60),
    seconds: pad(remaining % 60),
  }
}
